import { io, Socket } from 'socket.io-client';

export class SmoSocketServer {
  protected socket: Socket;

  public constructor(url: string) {
    this.socket = io(url, { transports: ['websocket'], upgrade: false });
  }
}
